<ng-container *ngIf="search">

    <button class="nrk-button filters-button" (click)="showFilters = !showFilters">Open Filters</button>
    <!-- <div class="customer-filter" [ngStyle]="{ 'opacity': nrkInfoOpacity, 'top' : nrkInfoOpacity ? '1rem' : '-1000rem' }"> -->
    <div class="customer-filter" *ngIf="showFilters">
        <!-- <ngx-doc-form-filter-select [(value)]="" -->
        <div>
            Select Customer(s)
            <ngx-doc-form-multiselect [(value)]="search.deliverynotes.customers" [options]="data.businessOptions"></ngx-doc-form-multiselect>
            <button class="nrk-button" (click)="reloadData()">Show Selected Customer(s)</button>
            <button class="nrk-button" (click)="search.deliverynotes.customers = [];reloadData()">Clear</button>
            <br><br>

            Select Delivery Note(s)
            <ngx-doc-form-multiselect [(value)]="search.deliverynotes.documentNumbers" [options]="documentNumberOptions"></ngx-doc-form-multiselect>
            <button class="nrk-button" (click)="reloadData()">Show Delivery Note(s)</button>
            <button class="nrk-button" (click)="search.deliverynotes.documentNumbers = [];reloadData()">Clear</button>
            <br><br>

            Select Place of Loading
            <ngx-doc-form-filter-select [(value)]="search.deliverynotes.placeOfLoading" [options]="data.businessOptions"></ngx-doc-form-filter-select>
            <button class="nrk-button" (click)="reloadData()">Show Place of Loading</button>
            <button class="nrk-button" (click)="search.deliverynotes.placeOfLoading = data.business.jerich?._id;reloadData()">Clear</button>
            <br><br>

            <div [style]="csOptions.length && !reportsPrinterComp.isReloadingData ? 'display:block' : 'display: none'">
                Select Combined Shipment
                <ngx-document-cs-selector
                    title="Select Combined Shipment"
                    [abstractItem]="shipment"
                    [mode]="selectorDisplayMode.input"
                    [latestVersionItems]="$any(csOptions)"
                    (compilationChange)="filterByCombinedShipment($event)"
                ></ngx-document-cs-selector>
                <!-- <ngx-doc-form-filter-select [(value)]="search.deliverynotes.placeOfLoading" [options]="data.businessOptions"></ngx-doc-form-filter-select> -->
                <button class="nrk-button" (click)="reloadData()">Filter by Combined Shipment</button>
                <button class="nrk-button" (click)="shipment = null;search.deliverynotes.combinedShipments = [];reloadData()">Clear</button>
                <br><br>
            </div>

            <div class="row">
                <div class="col-md-4">Sample request</div>
                <div class="col-md-8">
                <nb-radio-group name="warehousing-sr" class="row col-md-8" [(ngModel)]="this.search.deliverynotes.sampleRequest" (ngModelChange)="reloadData()">
                    <nb-radio [value]="1" checked>All (SR & no SR)</nb-radio>
                    <nb-radio [value]="2">SR only</nb-radio>
                    <nb-radio [value]="3">no SR</nb-radio>
                </nb-radio-group>
                </div>
            </div>
            <div class="mb-2">
                <button class="nrk-button" (click)="this.search.deliverynotes.sortType = 4;reloadData()">Sort Like Open Orders</button>
            </div>
            <!-- <ngx-loading-spinner [loading]="!csOptions.length || reportsPrinterComp.isReloadingData"></ngx-loading-spinner> -->

            Select DN Statuses
            <div class="select-dn-stati">
                <div [ngStyle]="{ 'background-color': filter.notReadyForPacking ? '#0c6a' : '#ddd' }">
                    <ngx-doc-form-checkbox label="Not Ready for Packing" [(value)]="filter.notReadyForPacking"></ngx-doc-form-checkbox>
                </div>
                <div [ngStyle]="{ 'background-color': filter.readyForPacking ? '#0c6a' : '#ddd' }">
                    <ngx-doc-form-checkbox label="Ready for Packing" [(value)]="filter.readyForPacking"></ngx-doc-form-checkbox>
                </div>
                <div [ngStyle]="{ 'background-color': filter.readyForDispatch ? '#0c6a' : '#ddd' }">
                    <ngx-doc-form-checkbox label="Ready for Dispatch" [(value)]="filter.readyForDispatch"></ngx-doc-form-checkbox>
                </div>
                <div [ngStyle]="{ 'background-color': filter.dispatched ? '#0c6a' : '#ddd' }">
                    <ngx-doc-form-checkbox label="Dispatched" [(value)]="filter.dispatched"></ngx-doc-form-checkbox>
                </div>
                <div [ngStyle]="{ 'background-color': filter.delivered ? '#0c6a' : '#ddd' }">
                    <ngx-doc-form-checkbox label="Delivered" [(value)]="filter.delivered"></ngx-doc-form-checkbox>
                </div>
                <!-- <div [ngStyle]="{ 'background-color': filter.delNotInvoiced ? '#0c6a' : '#ddd' }">
                    <ngx-doc-form-checkbox label="Delivered but not Invoiced" [(value)]="filter.delNotInvoiced"></ngx-doc-form-checkbox>
                </div> -->
            </div>

        </div>
    </div>

    <div class="nrk-info" [ngStyle]="{ 'opacity': nrkInfoOpacity, 'top' : nrkInfoOpacity ? '1rem' : '-1000rem' }">
        <div>
            <p>{{ nrkaInfo }}</p>
        </div>
        <div *ngIf="search.deliverynotes" style="top:15rem">
            <ngx-doc-form-date [(value)]="search.deliverynotes.dateFrom" title="Date From:"></ngx-doc-form-date>
            <br>
            <ngx-doc-form-date [(value)]="this.search.deliverynotes.dateTo" title="Date To:"></ngx-doc-form-date>
            <br>
            <button class="btn btn-sm btn-info" (click)="reloadData()">Apply</button>
            <br>
            <button class="btn btn-sm btn-info" (click)="printAllPackingInstructions()" [attr.disabled]="reportsPrinterComp.isReloadingData || !docCodes.length || null">Print All Packing Instructions<br>{{!docCodes.length ? '(none available)' : '(ready for packing)'}}</button>
        </div>
    </div>

    <!-- <nrk-window #logWindow>
        <nrk-header>Log</nrk-header>
        <nrk-content>test content</nrk-content>
        <nrk-footer>test footer</nrk-footer>
    </nrk-window>     -->

    <ngx-reports-printer #reportsPrinterComp [search]="search" [pdfSidebar]="true" [warehousing]="true" [messaging]="true" [dnStati]="filter" (scroll)="onScroll($event)" (done)="reportLoaded($event)" (docCodes)="onDocCodes($event)"></ngx-reports-printer>


    <div #coverSheet style="position:absolute;left:1000rem;">
        <ng-container *ngFor="let doc of currentDocuments">
            <div [id]="'doc_' + doc.code">
                <ng-container *ngFor="let li of doc.lineItems; index as idx">
                    <ngx-cover-sheet [print]="true" [compilation]="doc" [lineItemIdx]="idx"></ngx-cover-sheet>
                </ng-container>
            </div>
        </ng-container>
    </div>
    
</ng-container>
 